import { Input } from 'semantic-ui-react';

// HOCS
import withFormikInput from './withFormikInput';
import withFormField from './withFormField';
import withBlurTransform from './withBlurTransform';

export const NumberField = Input;

export const _NumberField = withFormField(NumberField);

const FormNumberField = withFormikInput(withBlurTransform(_NumberField), {
  passProps: ['setFieldValue'],
});

export default FormNumberField;
